import { useState, useEffect } from "react";
import Logo from "../../assets/Logo.svg";
import Telegram from "../../assets/Telegram.svg";
import BurgerMenu from "../../assets/UI Elements/BurgerMenu.svg";
import Menu from "./Menu";

export default function MainPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  return (
    <>
      <div
        className={`w-full sticky top-0 bg-white z-40 px-[24px] transition-shadow duration-200 overflow-hidden ${isScrolled ? "shadow-[0px_8px_20px_#0000000D]" : ""}`}
      >
        <div className="max-w-[1200px] w-full mx-auto py-[20px] flex justify-between items-center">
          <a href="/">
            <img src={Logo} alt="Logo" className="h-[24px] lg:h-[40px]" />
          </a>

          <nav className="hidden md:flex gap-[24px] text-[#4d4d4d]">
            <a href="/">О продукте</a>
            <a href="/#apps">Где скачать</a>
            {/* <a href="/#tariffs">Тарифы</a> */}
          </nav>

          <a
            href="https://t.me/sobesednik_supportbot"
            target="_blank"
            rel="noopener noreferrer"
            className="h-[24px] lg:h-[40px] pl-[10px] lg:pl-[12px] pr-0 lg:pr-[16px] hidden md:flex items-center gap-[8px] bg-[#f4f1ff] rounded-[12px] transition-[padding]"
          >
            <p className="text-[14px] lg:text-[16px] text-[#4d4d4d]">
              Поддержка
            </p>
            <img src={Telegram} alt="Logo" />
          </a>

          <button className="md:hidden" onClick={() => setIsMenuOpen(true)}>
            <img src={BurgerMenu} alt="BurgerMenu" />
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div
          className="fixed inset-0 z-50 bg-black/20 backdrop-blur-sm md:hidden"
          onClick={() => setIsMenuOpen(false)}
        />
      )}

      <Menu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </>
  );
}
